// extracted by mini-css-extract-plugin
export default {"renewalNote":"Q9d02ej2mQ2Ir7tWizV_"};